<div class="py-3">
  <div class="reset-container resetpass-wrap">
    <div class="header">Reset Password</div>
    <div class="reset-inner">
      <form (ngSubmit)="confirmPasswordd()">
        <div class="col-12 mob-container">
          <div>
            <div class="mt-1 user-info">Confirm Your New Password</div>
            <div class="provide-user-info">
              <p class="mb-0 m-resPassText">
                Your current password has expired. Please choose a new password.
              </p>
            </div>
            <div class="req"><span class="astrick">* </span> Required field</div>
          </div>
          <div class="col-md-5 userResetField">
            <label class="userField">
              New password <span class="astrick">*</span>
            </label>
            <input
              [ngClass]="{
                'border-invalid': !password1.valid && password1.touched,
                'border-valid': password1.valid
              }"
              type="password"
              class="form-control m-resPassTextarea"
              id="newPassword"
              name="newPassword"
              [(ngModel)]="newPassword"
              required
              #password1="ngModel"
              (keyup)="checkpassword(newPassword)"
              (keyup)="passwordValidation(true)"
              placeholder="Enter new password"
              value="password"
              minlength="8"
              maxlength="30"
              autocomplete="off"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$"
            />
  
            <ng-container class="passwordConfirmation" *ngIf="newPassword">
              <p
                class="mt-2 passwordConfirmation"
                [ngClass]="{
                  'text-danger': !blnHasCapital,
                  'text-success': blnHasCapital
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': blnHasCapital,
                    'fa-times-circle': !blnHasCapital
                  }"
                  aria-hidden="true"
                ></i>
                At least 1 upper case character
              </p>
              <p
                class="passwordConfirmation"
                [ngClass]="{
                  'text-danger': !blnLowerCase,
                  'text-success': blnLowerCase
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': blnLowerCase,
                    'fa-times-circle': !blnLowerCase
                  }"
                  aria-hidden="true"
                ></i>
                At least 1 lower case character
              </p>
              <p
                class="passwordConfirmation"
                [ngClass]="{
                  'text-danger': !blnHasOneNumber,
                  'text-success': blnHasOneNumber
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': blnHasOneNumber,
                    'fa-times-circle': !blnHasOneNumber
                  }"
                  aria-hidden="true"
                ></i>
                At least 1 numeric digit
              </p>
              <p
                class="passwordConfirmation"
                [ngClass]="{
                  'text-danger': !blnHasSpecialChar,
                  'text-success': blnHasSpecialChar
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': blnHasSpecialChar,
                    'fa-times-circle': !blnHasSpecialChar
                  }"
                  aria-hidden="true"
                ></i>
                1 non-alphanumeric character between [!@#$%^&*]
              </p>
              <p
                class="passwordConfirmation"
                [ngClass]="{
                  'text-danger': !blnHasLength,
                  'text-success': blnHasLength
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': blnHasLength,
                    'fa-times-circle': !blnHasLength
                  }"
                  aria-hidden="true"
                ></i>
                Password must be between 8 to 30 characters.
              </p>
              <p
                class="passwordConfirmation"
                [ngClass]="{
                  'text-danger': newPassword === loginScreenPassword,
                  'text-success': newPassword !== loginScreenPassword
                }"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-check-circle-o': newPassword !== loginScreenPassword,
                    'fa-times-circle': newPassword === loginScreenPassword
                  }"
                  aria-hidden="true"
                ></i>
                Not a previously used password.
              </p>
            </ng-container>
          </div>
          <div class="col-md-5 mt-3 userResetField">
            <label class="userField">
              Confirm new password <span class="astrick">*</span>
            </label>
            <input
              [ngClass]="{
                'border-invalid': !password2.valid && password2.touched,
                'border-valid': password2.valid
              }"
              type="password"
              class="form-control m-resPassTextarea"
              id="confirmNewPassword"
              name="confirmNewPassword"
              (value)="(confirmNewPassword)"
              placeholder="Confirm new password"
              [(ngModel)]="confirmNewPassword"
              required
              #password2="ngModel"
              minlength="8"
              maxlength="30"
              autocomplete="off"
              (keyup)="confirmPasswords(false)"
            />
  
            <div
              *ngIf="newPassword !== confirmNewPassword"
              class="text-danger error-message"
            >
              Password not matching
            </div>
          </div>
        </div>
        <div class="outer">
          <div class="userResetField col-md-12 m-responsiveUserField">
            <button class="btn next-btn provide-user-info mResponsiveBtn"
                    [ngClass]="{disabled: !(newPassword && confirmNewPassword && newPassword !== loginScreenPassword && newPassword === confirmNewPassword)}"
                    [disabled]="!(newPassword && confirmNewPassword && newPassword !== loginScreenPassword && newPassword === confirmNewPassword && blnPasswordBoxValid)">
              Submit
            </button>
          </div>
  
          <div class="userResetField col-md-12 m-responsiveUserFieldBottom">
            <button
              class="prev-btn provide-user-info mResponsiveBtn"
              (click)="redirectLogin()"
            >
              &lt; Back to Login
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
